import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '@services/ops-profiledata.service';
import { InterviewsStatus } from '@interfaces/vendor-profile.model';
import { ActivatedRoute } from '@angular/router';
import { InterviewStatus, VendorProfile, vendorProfileMetrics } from '@app/shared/constants/global.enum';
import { GlobalErrorService } from '@services/global-error.service';
import { onMonthChange, generateLast12MonthsVendor } from '@shared/utils/utils';

@Component({
  selector: 'app-interviews-status',
  templateUrl: './interviews-status.component.html',
  styleUrls: ['./interviews-status.component.scss'],
})
export class InterviewsStatusComponent implements OnInit {

  @Input() vendorId: string | null = null;
  interviewStatus = InterviewStatus;
  vendorProfile = VendorProfile;
  selectedMonth: string = '';
  selectedYear: string = '';
  data: InterviewsStatus | null = null;
  monthOptions: { value: string; label: string; month: string; year: string, selected?: boolean }[] = [];
  preSelectedValue: string = '';

  metrics: { key : keyof typeof InterviewStatus }[] = [
    { key: 'positionsOpened' },
    { key: 'profilesSubmitted' },
    { key: 'onBoardingPending' },
    { key: 'inProgress' },
  ];
  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private errorHandler: GlobalErrorService
  ) {}

  ngOnInit(): void {
    this.monthOptions = generateLast12MonthsVendor();
    const preSelectedOption = this.monthOptions.find(option => option.selected);
    if (preSelectedOption) {
      this.preSelectedValue = preSelectedOption.value;
      this.selectedMonth = preSelectedOption.month;
      this.selectedYear = preSelectedOption.year;
    }
    this.loadInterviewStatus();
  }

  onMonthChange(event: any): void {
    let selectedValue: string | undefined;
      if (typeof event === 'string') {
      const monthOption = this.monthOptions.find(option => option.label === event);
      selectedValue = monthOption ? monthOption.value : undefined;
    } else if (event.value) {
      selectedValue = event.value;
    }
      if (!selectedValue || !this.monthOptions.some(option => option.value === selectedValue)) {
      this.errorHandler.showError(this.vendorProfile.invalidMonthSelected);
      return;
    }
    const selectedOption = this.monthOptions.find(option => option.value === selectedValue);
    if (selectedOption) {
      this.selectedMonth = selectedOption.month;
      this.selectedYear = selectedOption.year;
      this.preSelectedValue = selectedOption.value;
      this.loadInterviewStatus();
    }
  }

  loadInterviewStatus(): void {
      this.dataService
        .getInterviewStatus(this.vendorId, this.selectedMonth, this.selectedYear)
        .subscribe({
          next: (response) => {
            console.log(response);
            this.data = response.data || null;
          },
          error: () => {
            this.errorHandler.showError(this.vendorProfile.failedToLoadContractorHeadCount);
          },
        });
    }
}
